<template>
    <div class="computerBox">
        <!-- 固定到顶部加上 fixed top-0  -->
        <!-- <backPage :title="$route.meta.title" /> -->
        <topBox :title="$route.meta.title" />
        <!-- <div class="h-[44px] z-50 w-[375px]">
            <div class="flex justify-between items-center px-[16px] py-[7px] h-[30px] w-[375px]">
                <div class="text-ms w-[30px] h-[30px] py-[7px]">
                    <router-link to="#" @click="$router.back()">
                        <svg class="w-[30px] h-[30px]"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                            <path fill="#283643" d="M34.5 239L228.9 44.7c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9L131.5 256l154 154.8c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0L34.5 273c-9.4-9.4-9.4-24.6 0-33.9z"/>
                        </svg>
                    </router-link>
                </div>
                <div class="text-ms w-[30px] h-[30px] py-[7px]">
                    
                </div>
            </div>
        </div> -->
        <!-- 内容区 -->
        <div class="px-[36px] w-full mt-[80px]">

            <main>
                <div>
                    <div class="my-3">
                        <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('title.account') }}</h1>
                        <input
                            type="text"
                            class="block w-full px-[35px]  py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1  focus:outline-none text-ms"
                            :placeholder="$t('placeholder.account')"
                            v-model="input.account"
                        />
                    </div>
                    <div class="my-2">
                        <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('title.password') }}</h1>
                        <input
                            type="password"
                            class="block w-full px-[35px] py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1 focus:outline-none  text-ms"
                            :placeholder="$t('placeholder.password')"
                            v-model="input.password"
                        />
                    </div>

                    <div class="my-2 mt-6">
                        <!-- 滑块验证组件 -->
                        <SlideVerify @success="isVerified = true" />
                    </div>

                </div>
                
            </main>

            

            <div class="mt-0 py-[25px]">
                <button
                    class="block w-full px-5  py-[15px] border rounded-full butSubmit text-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1  focus:outline-none text-xs-xs"
                    x-bind:disabled="!isValid"
                    @click="onSubmit"
                >
                    {{ $t('but.login') }}
                </button>
            </div>

            

            <div class="text-xs-xs flex justify-center">
                <router-link to="/computer/register">
                    <div class="color-y">{{ $t('text.regTip') }}</div>
                </router-link>
            </div>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { ref, watch } from 'vue'
// import topMenu from "@/components/computer/TopMenu.vue"
import mainMenu from "@/components/computer/MainMenu.vue"
// import backPage from "@/components/computer/BackPage.vue"
import topBox from "@/components/computer/TopBox.vue"
import axios from 'axios'
import { layer } from "vue3-layer"
import global from '@/assets/js/global' // 全局变量
import { useGlobalStore } from '@/assets/js/globalStore'
import SlideVerify from '@/components/SlideVerify.vue'
export default {
    components: {
        // backPage,
        topBox,
        // topMenu,
        mainMenu,
        SlideVerify
    },
    data() {
        return {
            lang: '',
            input: {
                account: '',
                password: '',
            }
        }
    },
    setup() {
        // 获取临时令牌函数：操作注册帐号的API请求时需要携带临时令牌
        const getApiToken = () => {
            // Ws 还没有绑定客户端 不可以发起请求
            if (!global.isBind || 1 !== global.wssConnection.readyState) {
                console.log('连接未就绪，请稍后重试')
                return false
            }
            // 监听 WS 服务端的响应 对结果进行处理 结果一到位就会响应
            getApiTokenWork() 
            // 向 WS 服务端发起登录请求
            global.wssConnection.send(
                JSON.stringify({'event':'task', 'task':'member.get.api.reg.token', 'type': 'reg', 'account':global.token, 'id':global.wssConID})
            )
        }

        const time = ref(100)
        const timeObj = ref(null)
        // 以百分之一秒的速度递归 监听WS服务端的响应 判断是否登录成功
        const getApiTokenWork = () => {
            timeObj.value = setTimeout(() => {
                if (false!==global.response && 'apiToken'===global.response.event ) { // 确保全局WS响应数据有值 并且是本请求对应的响应数据 才可以进行处理
                    if (0===global.response.data.code) wsGetSuccess() // 正确处理
                    global.response = false // 处理完数据 要把数据清空
                    clearTimeout(timeObj) // 清除定时器，因为已经处理完数据了
                } else {
                    getApiTokenWork() // 什么时候结束递归？得到 WS 响应的结果时不再递归，即 global.response = false 时就不再递归
                }
            }, time)
        }

        // WS 获取临时令牌成功后的处理函数
        const wsGetSuccess = () => {
            localStorage.setItem('tokenApi', global.response.data.token)
        }

        const isVerified = ref(false) // 滑块验证是否通过
        const handleRegister = () => { // 滑块验证处理逻辑
            var status = true
            if (!isVerified.value) {
                status = false
            }
            return status
        }
        // 监听 isVerified 的变化
        watch(isVerified, (newValue, oldValue) => {
            // console.log(`newValue: ${newValue}, oldValue: ${oldValue}`)
            if (newValue !== oldValue && newValue === true) {
                getApiToken() // 获取临时令牌，用来注册帐号。
            }
        })

        return {
            isVerified, handleRegister
        }
    },
    mounted() {
        // 切换语言
        const { locale } = useI18n()  // 从国际化中取出配置项 locale 因为初始化时 用户没有指定语种 要使用系统默认的语种
        this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : locale.value // 如果用户有选择特定语种 就使用用户指定的 不然就使用系统默认的
        locale.value = this.lang

        return {}
    },
    methods: {
        onSubmit() {
            // console.log('登录')
            axios.post(
                '/api/login', 
                {
                    app_id: global.app_id,      // 用来区分不同系统的 app_id
                    app_key: global.app_key,    // 用来区分不同系统的 app_key
                    account: this.input.account,
                    passkey: this.input.password,
                    token_api: localStorage.getItem('tokenApi')
                },
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data'
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        'token': localStorage.getItem('token')
                    }
                }
            )
            .then((response) =>  {
                // console.log(response.data)
                if (0===response.data.code) {
                    localStorage.setItem('token', response.data.data.token)
                    localStorage.setItem('isLogin', true)
                    localStorage.setItem('isAgent', response.data.data.is_agent)
                
                    global.token = response.data.data.token
                    global.isLogin = true
                    global.isAgent = response.data.data.is_agent
                    const globalStore = useGlobalStore()
                    globalStore.setLogin(true)  // 保证写入时，写入的是布尔值
                    globalStore.setIsAgent(response.data.data.is_agent)  // 保证写入时，写入的是布尔值

                    // 跳转
                    this.$router.push({
                        path: '/computer/user',
                        query: {
                            msg: 'reg account'
                        }
                    })
                } else if (1===response.data.code) {
                    // let word = response.data.data.id
                    // let key = word.charAt(0).toUpperCase() + word.slice(1)
                    // 转成国际化 后端转提示语 前端转表单名称
                    // let msg = this.$t(`input.${key}`) + ' ' + response.data.msg 
                    layer.msg(response.data.data.msg )
                } else if (2===response.data.code) {
                    layer.msg(response.data.data.msg )
                }
            })
            .catch(function (error) {
                console.log(error)
            })
        }
    }
}
</script>

<style lang="scss" scoped>

    .computerBox {
        /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
    }

    #loginBox {
        // background: linear-gradient(270deg, #f7395f 0%, #fe702e 100%); 
        // background-image: url('/public/upload/6x4.png');
        // background-repeat: no-repeat;
    }

    .form-select {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%239ca3af' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 0.5rem center;
        background-size: 1.5em 1.5em;
        -webkit-tap-highlight-color: transparent;
      }

      .submit-button:disabled {
        cursor: not-allowed;
        background-color: #D1D5DB;
        color: #111827;
      }

      .submit-button:disabled:hover {
        background-color: #9CA3AF;
      }

      .credit-card {
        max-width: 420px;
        margin-top: 3rem;
      }

      @media only screen and (max-width: 420px)  {
        .credit-card .front {
          font-size: 100%;
          padding: 0 2rem;
          bottom: 2rem !important;
        }

        .credit-card .front .number {
          margin-bottom: 0.5rem !important;
        }
      }

</style>